import { Link as MuiLink, Typography } from '@mui/material';
import { makeStyles } from '~/UIKit/Style';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { getCurrentYear } from '../../Helpers/Date.helper';

const useStyles = makeStyles({
  footer: {
    textAlign: 'center',
    marginTop: 30,
    marginBottom: 50,
  },
  footerText: {
    fontSize: '13px',
  },
  link: {
    textDecoration: 'none',
  },
});

export interface ICopyrightFooterProps {
  isUsingThePartnerTool?: boolean;
  usc?: boolean;
}

export const CopyrightFooter = ({ isUsingThePartnerTool, usc }: ICopyrightFooterProps) => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  return (
    <div className={classes.footer}>
      {!usc && (
        <>
          <Typography align="center" className={classes.footerText} noWrap variant="body2">
            ©{getCurrentYear()} {t('app.copyRight')}
          </Typography>
        </>
      )}
      {(isUsingThePartnerTool || usc) && (
        <Typography className={classes.footerText}>
          <MuiLink
            className={classes.link}
            color="primary"
            href={t('partner.TACLink')}
            underline="always"
            target="_blank"
          >
            {t('app.t&c')}
          </MuiLink>{' '}
          {t('app.and')}{' '}
          <MuiLink
            className={classes.link}
            color="primary"
            href={t('partner.privacyPolicyLink')}
            underline="always"
            target="_blank"
          >
            {t('copyright.privacyPolicy')}
          </MuiLink>{' '}
          {' Urban Sports Club'}
        </Typography>
      )}
    </div>
  );
};
